<template>
  <textarea
    :placeholder="placeholder || ''"
    :value="modelValue"
    :rows="rows || 3"
    :readonly="Boolean(readonly)"
    class="ui-textarea"
    @input="onInput"
  />
</template>

<script setup lang="ts">
import { useAutoLabel } from '@/shared/lib/autoLabel'
useAutoLabel()

const props = withDefaults(
  defineProps<{
    modelValue: string
    placeholder?: string
    rows?: number
    readonly?: boolean
  }>(),
  {
    placeholder: '',
    rows: 3,
    readonly: false,
  },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

function onInput(event: Event) {
  if (props.readonly) return
  const target = event.target as HTMLTextAreaElement
  emit('update:modelValue', target.value)
}
</script>

<style scoped>
.ui-textarea {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  width: 100%;
  font: inherit;
  resize: vertical;
  min-height: 80px;
  box-sizing: border-box;
}

.ui-textarea:read-only {
  background: #f8fafc;
  color: #586578;
  cursor: default;
}
</style>
